import { AssetType } from 'config/consts';
import React from 'react';
import { ProfitOrLossItemProps } from './ProfitAndLossStuffing';
import {
  AboutExchangeRateModalButton,
  DataFetchingState,
  getDataFetchingState,
} from '../PortfolioStuffing/asset/PortfolioStuffingAsset';
import { getDataFetchingTextStyle_ } from '../PortfolioRatioStuffing/PortfolioRatioStuffingList';
import { DataFetching } from '../PortfolioStuffing/asset/AssetOrganizedPortfolioItem';
import { addSignCommaFormat } from 'components/features/new-report/utils/formatter';
import { useRouting } from 'hooks/useRouting';
import { AssetTypesLabel } from 'components/features/utils/assetType';
import { amountToAmountColor } from 'components/features/utils/util';

export const ProfitOrLossItem = ({
  assetTypeKey,
  side,
  profitOrLossAmount,
  identifier,
  name,
  link,
  profitOrLossAmountForeign,
  profitOrLossAmountForeignUnit,
}: ProfitOrLossItemProps): React.ReactElement => {
  const { pushRouting } = useRouting();

  const amountColor = amountToAmountColor(profitOrLossAmount ?? 0);
  const amount = addSignCommaFormat(profitOrLossAmount);
  const amountForeign =
    profitOrLossAmountForeign !== undefined
      ? addSignCommaFormat(profitOrLossAmountForeign, { numberOfDecimals: 2 })
      : '---';
  const unitForeign = profitOrLossAmountForeignUnit ?? '';
  const dataFetchingState: DataFetchingState = getDataFetchingState(
    identifier,
    assetTypeKey
  );
  const getDataFetchingTextStyle = getDataFetchingTextStyle_(dataFetchingState);

  // MEMO: 『類推中』はMONO-***、『類推完了』はDC-***で返却
  const isDataCooperation =
    assetTypeKey === AssetType['投資信託'] && /^MONO/.test(identifier);

  const goTradeDetail = () => {
    link && pushRouting({ path: link }, true);
  };

  return (
    <>
      <div
        className={`${
          isDataCooperation ? 'text-bluegray-300' : 'text-bluegray-700'
        }`}>
        <div className="border-b border-bluegray-300">
          <div
            className={`flex items-center pt-4 ${
              link ? 'cursor-pointer' : ''
            } ${
              profitOrLossAmountForeign && profitOrLossAmountForeignUnit
                ? ''
                : 'pb-4'
            }
            `}
            onClick={(): void => goTradeDetail()}>
            <div className="flex-1 min-w-0 ml-2">
              {isDataCooperation && (
                <div className={`flex flex-row mb-2`}>
                  <DataFetching />
                </div>
              )}
              <div className="flex items-center mb-1">
                <AssetTypesLabel assetType={assetTypeKey} />
                <div className="ml-2 text-sm text-bluegray-500">
                  {identifier}
                </div>
              </div>
              <div className="w-full flex items-end leading-6">
                <div className={`text-base font-bold line-clamp-2 pr-2`}>
                  {name}
                </div>
                <div
                  className={`flex flex-row flex-shrink ml-auto font-bold ${amountColor}`}
                  style={{ whiteSpace: 'nowrap' }}>
                  <div className="text-base mr-1">{amount}</div>
                  <div className="text-xs">円</div>
                </div>
              </div>
            </div>
            {link ? (
              <div className="flex items-center ml-4 w-2">
                {link && (
                  <img
                    className="w-full"
                    src="/static/images/icon/icon-arrow-right.svg"
                    alt=""
                  />
                )}
              </div>
            ) : (
              <div className="ml-4 w-2"></div>
            )}
          </div>
          {profitOrLossAmountForeign !== undefined &&
            profitOrLossAmountForeign !== null &&
            profitOrLossAmountForeignUnit && (
              <div className="flex">
                <div
                  className="flex flex-1 items-center justify-center mr-4 pb-4"
                  onClick={e => e.stopPropagation()}>
                  <div
                    className={`${getDataFetchingTextStyle(
                      amountColor
                    )} text-sm ml-auto`}>
                    ({amountForeign} {unitForeign})
                  </div>
                  <AboutExchangeRateModalButton
                    isShowMessage={false}
                    className="ml-2"
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};
